const form = {
  formFieldWrap: {
    clearFieldBtn: 'נקה',
  },
};

export default form;
